import script from "./help.vue?vue&type=script&setup=true&lang=js"
export * from "./help.vue?vue&type=script&setup=true&lang=js"

import "./help.vue?vue&type=style&index=0&id=576588a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576588a6"]])

export default __exports__